var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArticulation = function SvgArticulation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 111 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeWidth: 3,
    d: "M106.5 55.984c0 23.88-21.562 43.5-48.5 43.5-3.777 0-7.451-.387-10.977-1.118-7.437-1.544-15.632-1.52-22.488 2.484a17 17 0 0 1-4.474 1.823l-1.145.286c-3.097.775-5.247-3.022-2.99-5.28a5.2 5.2 0 0 0 1.277-2.087l2.06-6.382c1.04-3.22.204-6.627-1.71-9.216C12.456 73.103 9.5 64.85 9.5 55.984c0-23.88 21.562-43.5 48.5-43.5s48.5 19.62 48.5 43.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7B4EF8",
    d: "M60.056 71.016h-3.91l11.31-30.803h3.85l11.31 30.803h-3.91L69.5 45.086h-.24zM61.5 58.983h15.762v3.31H61.5zM35.892 59.016h-2.216l6.41-17.455h2.181l6.41 17.455H46.46l-5.216-14.694h-.136zm.818-6.819h8.932v1.875H36.71zM31.06 82.016h-1.564l4.524-12.321h1.54l4.524 12.32H38.52l-3.682-10.371h-.096zm.577-4.813h6.305v1.323h-6.305z"
  })));
};
export default SvgArticulation;